import '@builder.io/widgets';
import BuilderResource from './components/BuilderResource';
import registerBuilderComponents from '~/javascripts/utils/registerBuilderComponents';
import renderComponentFromEl from '~/javascripts/utils/renderComponentFromEl';
import { Builder, builder } from '@builder.io/react';
import { debounce, isEqual } from 'lodash';
import { render } from 'react-dom';
import { unmountComponentAtNode } from 'react-dom';
import { useEffect, useRef, useState } from 'react';

window.BuilderServerComponentsMarkup = {};
const BuilderServerComponents = {};

function initBuilder() {
  if (!window.BuilderEnabledPage) return;

  builder.canTrack = false;
  builder.init(window.BuilderApiKey);

  document.querySelectorAll('[data-builder-resource]').forEach(async (el) => {
    const {
      locale,
      builderResource,
      builderResourceId,
      builderAdditionalData,
      isUkSite,
      isPreview,
    } = el.dataset;

    const content = await fetch(
      `/api/v1/builder/content?resourceName=${builderResource}&resourceId=${builderResourceId}&locale=${locale}&isPreview=${isPreview}&additionalData=${builderAdditionalData}&isUkSite=${isUkSite}`
    ).then((response) => response.json());

    window.BuilderServerComponentsMarkup[builderResourceId] = {};

    el.querySelectorAll('[data-server-component]').forEach((el) => {
      const blockId = el.dataset.builderId;

      window.BuilderServerComponentsMarkup[builderResourceId][blockId] =
        el.innerHTML;
    });

    window.AllBuilderServerComponents.forEach((component) => {
      BuilderServerComponents[component] = (props) => {
        const wrapperRef = useRef(null);
        const [markup, setMarkup] = useState(
          window.BuilderServerComponentsMarkup[builderResourceId][
            props.builderBlock.id
          ]
        );

        const getMarkupAndMountComponents = debounce(async () => {
          const serverMarkup = await fetch('/api/v1/builder/server_component', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              builderBlock: props.builderBlock,
              resourceId: builderResourceId,
              resourceName: builderResource,
              isUkSite: isUkSite,
            }),
          })
            .then((response) => response.json())
            .then((data) => data.markup);

          setMarkup(serverMarkup);

          wrapperRef.current
            ?.querySelectorAll('[data-component]')
            .forEach((el) => {
              renderComponentFromEl(el);
            });
        }, 200);

        const lastOptionsRef = useRef(props.builderBlock.component.options);

        useEffect(() => {
          htmx.process(wrapperRef.current);
          if (!Builder.isEditing) return;

          const currentOptions = props.builderBlock.component.options;
          const prevOptions = lastOptionsRef.current;

          if (isEqual(currentOptions, prevOptions)) return;

          lastOptionsRef.current = currentOptions;

          wrapperRef.current
            ?.querySelectorAll('[data-component]')
            .forEach((el) => {
              unmountComponentAtNode(el);
            });

          getMarkupAndMountComponents();

          return () => {
            getMarkupAndMountComponents.cancel();
          };
        }, [props.builderBlock.component.options]);

        return (
          <div dangerouslySetInnerHTML={{ __html: markup }} ref={wrapperRef} />
        );
      };
    });

    registerBuilderComponents(BuilderServerComponents);

    render(
      <BuilderResource
        content={content}
        locale={locale}
        resourceName={builderResource}
        theme={window.BuilderTheme}
      />,
      el.querySelector('[data-name]')
    );
  });
}

document.addEventListener('alpine:initialized', initBuilder);
